import GalleryLayoutStep from './gallery-layout-step';

export default {
  GalleryLayoutStep,
};
